<script>
export let href = "#/";
export let target = "_self";
export let redirect = false;
export let has_span = false;

if(href === ""){
    href = null
}
</script>
{#if href !== null && has_span === false}
    {#if !redirect}
        <!-- default layout -->
        <a href="{href}" target="{target}" class="{$$props?.class ?? ""} static-link no-decoration" on:click|preventDefault>
            <slot></slot>
        </a>
    {:else}
        <!-- on normal redirect needed layout (note the on:click event removed to execute a normal redirection) -->
        <a href="{href}" target="{target}" class="{$$props?.class ?? ""} static-link no-decoration">
            <slot></slot>
        </a>
    {/if}
{:else}
        <!-- Span with href null -->
        <clickable-node role="button" tabindex="0" class="{$$props?.class ?? ""} static-link no-decoration" on:click|preventDefault on:keydown|preventDefault>
            <slot></slot>
        </clickable-node>
{/if}
<style>
a :global(*){
    text-decoration: none;
}
</style>